import { forEach } from './forEach';
/**
 * Removes focus on links, when click is released.
 */

export function releaseFocus() {
  forEach(document.querySelectorAll('a, button'), function (el) {
    el.addEventListener('mouseup', function () {
      this.blur();
    });
  });
}